'use client';

import { useContext, useEffect, useState } from 'react';

import { RealEstateDict } from '@monoimin/intl';
import { useParamsUpdater } from '@monoimin/hooks';
import { IconNamesUnion } from '@monoimin/sb-types';

import { Input } from '@monoimin/molecules/inputs/RealEstateInput';

import { FiltersContext } from './FiltersProvider';

import type {
  InputFilterVariants,
  FilterPlaceholderKey,
  EstateFillterKeys,
} from '../../types';

type InputFilterProps = {
  className?: string;
  filteKey: EstateFillterKeys;
  placeholderDictionaryKey: FilterPlaceholderKey;
  realEstateDict: RealEstateDict;
  variant: InputFilterVariants;
  icon?: IconNamesUnion;
};

export const FilterInput = ({
  className,
  filteKey,
  realEstateDict,
  placeholderDictionaryKey,
  variant,
  icon,
}: InputFilterProps) => {
  const [filtersState] = useContext(FiltersContext);

  const { onChange: onParamsChange } = useParamsUpdater();

  const current = filtersState?.[filteKey];

  const [value, setValue] = useState<string | number>('');

  // Вынести выше
  const placeholder = realEstateDict[placeholderDictionaryKey];

  useEffect(() => {
    if (typeof current === 'string' || typeof current === 'number') {
      setValue(current);
    }
  }, [current]);

  return (
    <Input
      placeholder={placeholder as string}
      value={value}
      type={variant}
      className={className}
      icon={icon}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          onParamsChange({
            [filteKey]: value,
          });
        }
      }}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      size='large'
    />
  );
};
